import React from "react"
import PropTypes from "prop-types"

import styles from "../../styles.css"

const TableHeader = ({ children, ...props }) => {
  return (
    <th {...props} className={styles.tableHeader}>
      {children}
    </th>
  )
}

TableHeader.propTypes = {
  children: PropTypes.node
}
export default TableHeader



// WEBPACK FOOTER //
// ./src/components/Table/components/TableHeader/index.js